import './index.scss'
$("#nav6").addClass("active");